import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
export const index = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/document/comments',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
index.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return index.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
index.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
index.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
const indexForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
indexForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::index
* @see Http/Controllers/DocumentCommentController.php:16
* @route '/projects/{project}/document/comments'
*/
indexForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\DocumentCommentController::store
* @see Http/Controllers/DocumentCommentController.php:35
* @route '/projects/{project}/document/comments'
*/
export const store = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/projects/{project}/document/comments',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\DocumentCommentController::store
* @see Http/Controllers/DocumentCommentController.php:35
* @route '/projects/{project}/document/comments'
*/
store.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return store.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentCommentController::store
* @see Http/Controllers/DocumentCommentController.php:35
* @route '/projects/{project}/document/comments'
*/
store.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::store
* @see Http/Controllers/DocumentCommentController.php:35
* @route '/projects/{project}/document/comments'
*/
const storeForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::store
* @see Http/Controllers/DocumentCommentController.php:35
* @route '/projects/{project}/document/comments'
*/
storeForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\DocumentCommentController::reply
* @see Http/Controllers/DocumentCommentController.php:63
* @route '/projects/{project}/document/comments/{thread}/reply'
*/
export const reply = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

reply.definition = {
    methods: ["post"],
    url: '/projects/{project}/document/comments/{thread}/reply',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\DocumentCommentController::reply
* @see Http/Controllers/DocumentCommentController.php:63
* @route '/projects/{project}/document/comments/{thread}/reply'
*/
reply.url = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            thread: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        thread: typeof args.thread === 'object'
        ? args.thread.id
        : args.thread,
    }

    return reply.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{thread}', parsedArgs.thread.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentCommentController::reply
* @see Http/Controllers/DocumentCommentController.php:63
* @route '/projects/{project}/document/comments/{thread}/reply'
*/
reply.post = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::reply
* @see Http/Controllers/DocumentCommentController.php:63
* @route '/projects/{project}/document/comments/{thread}/reply'
*/
const replyForm = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::reply
* @see Http/Controllers/DocumentCommentController.php:63
* @route '/projects/{project}/document/comments/{thread}/reply'
*/
replyForm.post = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reply.url(args, options),
    method: 'post',
})

reply.form = replyForm

/**
* @see \App\Http\Controllers\DocumentCommentController::resolve
* @see Http/Controllers/DocumentCommentController.php:85
* @route '/projects/{project}/document/comments/{thread}/resolve'
*/
export const resolve = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: resolve.url(args, options),
    method: 'patch',
})

resolve.definition = {
    methods: ["patch"],
    url: '/projects/{project}/document/comments/{thread}/resolve',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\DocumentCommentController::resolve
* @see Http/Controllers/DocumentCommentController.php:85
* @route '/projects/{project}/document/comments/{thread}/resolve'
*/
resolve.url = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            thread: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        thread: typeof args.thread === 'object'
        ? args.thread.id
        : args.thread,
    }

    return resolve.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{thread}', parsedArgs.thread.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentCommentController::resolve
* @see Http/Controllers/DocumentCommentController.php:85
* @route '/projects/{project}/document/comments/{thread}/resolve'
*/
resolve.patch = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: resolve.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::resolve
* @see Http/Controllers/DocumentCommentController.php:85
* @route '/projects/{project}/document/comments/{thread}/resolve'
*/
const resolveForm = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::resolve
* @see Http/Controllers/DocumentCommentController.php:85
* @route '/projects/{project}/document/comments/{thread}/resolve'
*/
resolveForm.patch = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

resolve.form = resolveForm

/**
* @see \App\Http\Controllers\DocumentCommentController::reopen
* @see Http/Controllers/DocumentCommentController.php:102
* @route '/projects/{project}/document/comments/{thread}/reopen'
*/
export const reopen = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: reopen.url(args, options),
    method: 'patch',
})

reopen.definition = {
    methods: ["patch"],
    url: '/projects/{project}/document/comments/{thread}/reopen',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\DocumentCommentController::reopen
* @see Http/Controllers/DocumentCommentController.php:102
* @route '/projects/{project}/document/comments/{thread}/reopen'
*/
reopen.url = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            thread: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        thread: typeof args.thread === 'object'
        ? args.thread.id
        : args.thread,
    }

    return reopen.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{thread}', parsedArgs.thread.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentCommentController::reopen
* @see Http/Controllers/DocumentCommentController.php:102
* @route '/projects/{project}/document/comments/{thread}/reopen'
*/
reopen.patch = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: reopen.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::reopen
* @see Http/Controllers/DocumentCommentController.php:102
* @route '/projects/{project}/document/comments/{thread}/reopen'
*/
const reopenForm = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reopen.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::reopen
* @see Http/Controllers/DocumentCommentController.php:102
* @route '/projects/{project}/document/comments/{thread}/reopen'
*/
reopenForm.patch = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reopen.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

reopen.form = reopenForm

/**
* @see \App\Http\Controllers\DocumentCommentController::destroy
* @see Http/Controllers/DocumentCommentController.php:116
* @route '/projects/{project}/document/comments/{thread}'
*/
export const destroy = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/projects/{project}/document/comments/{thread}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\DocumentCommentController::destroy
* @see Http/Controllers/DocumentCommentController.php:116
* @route '/projects/{project}/document/comments/{thread}'
*/
destroy.url = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            thread: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        thread: typeof args.thread === 'object'
        ? args.thread.id
        : args.thread,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{thread}', parsedArgs.thread.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentCommentController::destroy
* @see Http/Controllers/DocumentCommentController.php:116
* @route '/projects/{project}/document/comments/{thread}'
*/
destroy.delete = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::destroy
* @see Http/Controllers/DocumentCommentController.php:116
* @route '/projects/{project}/document/comments/{thread}'
*/
const destroyForm = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DocumentCommentController::destroy
* @see Http/Controllers/DocumentCommentController.php:116
* @route '/projects/{project}/document/comments/{thread}'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number }, thread: string | number | { id: string | number } } | [project: string | number | { id: string | number }, thread: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const comments = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    reply: Object.assign(reply, reply),
    resolve: Object.assign(resolve, resolve),
    reopen: Object.assign(reopen, reopen),
    destroy: Object.assign(destroy, destroy),
}

export default comments